module.exports = "/images/icon-protected.png?227f0d4327bfffa01f48e51d5f8e610f";